import { useState } from 'react';

import Pagination, { DropdownOptions } from '../../../../../common/Pagination';
import { Table } from '../../../../../common/Table';
import { TeamMemberStats } from '../../../types/checkInStats';
import { sortTeamMembers } from '../../../utils';

import { TEAM_MEMBER_STATS_COLUMNS } from './constants';

interface TeamMemberStatsTableProps {
  teamMembers: TeamMemberStats[];
}

export function TeamMemberStatsTable({
  teamMembers,
}: TeamMemberStatsTableProps): JSX.Element {
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const handlePerPageChange = (option: DropdownOptions | null): void => {
    if (option) {
      setCurrentPage(1);
      setPerPage(Number(option.value));
    }
  };
  const currentPagedata = sortTeamMembers(teamMembers).slice(
    (currentPage - 1) * perPage,
    currentPage * perPage,
  );
  return (
    <div className="mt-4 bg-white rounded-lg p-4">
      <Table data={currentPagedata} columns={TEAM_MEMBER_STATS_COLUMNS} />
      <hr />
      <Pagination
        totalResults={teamMembers.length}
        currentPage={currentPage}
        perPage={perPage}
        onPerPageChange={handlePerPageChange}
        onPageChange={setCurrentPage}
      />
    </div>
  );
}
